import React from 'react';
import { PageContainer } from '@/components/ui/PageContainer/PageContainer';
import { usePageHeader } from '@/hooks/usePageHeader';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card/Card';
import { HStack, VStack } from '@/components/ui/Stack';
import { MailSettingsCard } from '@/components/admin/MailSettingsCard';
import { StorageSettingsCard } from '@/components/admin/StorageSettingsCard';
import { PlatformAISettings } from './PlatformAISettings';
import { Brain } from 'lucide-react';
import { t } from '@/lib/i18n';

export function AdminSettings() {
  usePageHeader({ title: t('Integrations'), breadcrumbs: [{ label: t('Admin'), path: '/admin/orgs' }] });

  return (
    <PageContainer>

      <div className="space-y-6">
        {/* Mail Configuration */}
        <MailSettingsCard />

        {/* Storage Configuration */}
        <StorageSettingsCard />

        {/* Platform AI & LLM Providers */}
        <Card>
          <CardHeader>
            <HStack spacing={2} className="items-center">
              <Brain className="w-5 h-5 text-primary-600" />
              <VStack spacing={0} className="flex-1">
                <CardTitle>AI & LLM Providers</CardTitle>
                <CardDescription>
                  Configure platform-level AI provider API keys. These serve as defaults for organizations without their own keys.
                </CardDescription>
              </VStack>
            </HStack>
          </CardHeader>
          <CardContent>
            <PlatformAISettings embedded />
          </CardContent>
        </Card>
      </div>
    </PageContainer>
  );
}
